module.exports = __webpack_public_path__ + "img/wifi-solid.b7fbc679.svg";